import { Fragment, useMemo, useState } from "react";
import { Combobox, Transition } from "@headlessui/react";

export default function SearchableUserSelect({
  users = [],
  value = null,
  onChange,
  placeholder = "Search users...",
}) {
  const [query, setQuery] = useState("");

  const selectedUser =
    users.find((u) => Number(u.id) === Number(value)) || null;

  const filteredUsers = useMemo(() => {
    const q = query.trim().toLowerCase();

    if (!q) return users;

    return users.filter((u) => {
      const name = (u.name || "").toLowerCase();
      const email = (u.email || "").toLowerCase();
      return name.includes(q) || email.includes(q);
    });
  }, [users, query]);

  return (
    <Combobox
      value={selectedUser}
      onChange={(user) => {
        onChange(user ? user.id : null);
        setQuery("");
      }}
    >
      <div className="relative">
        <Combobox.Input
          className="border p-2 w-full"
          displayValue={(user) => user?.name || ""}
          onChange={(event) => setQuery(event.target.value)}
          placeholder={placeholder}
        />

        <Transition
          as={Fragment}
          leave="transition ease-in duration-100"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
          afterLeave={() => setQuery("")}
        >
          <Combobox.Options className="absolute z-20 mt-1 max-h-60 w-full overflow-auto rounded border bg-white shadow-lg">
            <Combobox.Option
              value={null}
              className={({ active }) =>
                `cursor-pointer select-none px-3 py-2 ${
                  active ? "bg-blue-100" : ""
                }`
              }
            >
              Unassigned / None
            </Combobox.Option>

            {filteredUsers.length === 0 ? (
              <div className="px-3 py-2 text-sm text-gray-500">
                No users found
              </div>
            ) : (
              filteredUsers.map((user) => (
                <Combobox.Option
                  key={user.id}
                  value={user}
                  className={({ active }) =>
                    `cursor-pointer select-none px-3 py-2 ${
                      active ? "bg-blue-100" : ""
                    }`
                  }
                >
                  <div className="flex flex-col">
                    <span>{user.name}</span>
                    {user.email ? (
                      <span className="text-xs text-gray-500">{user.email}</span>
                    ) : null}
                  </div>
                </Combobox.Option>
              ))
            )}
          </Combobox.Options>
        </Transition>
      </div>
    </Combobox>
  );
}